"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Msg = exports.LoadingContainer = void 0;
const ui_theme_1 = require("@kyruus/ui-theme");
const styled_1 = __importDefault(require("@emotion/styled"));
exports.LoadingContainer = (0, styled_1.default)('div') `
  display: flex;
  align-items: center;
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_xlarge')};
`;
exports.Msg = (0, styled_1.default)('div') `
  margin-left: ${(0, ui_theme_1.fromTheme)('spacing_large')};
`;
//# sourceMappingURL=styles.js.map